import React from "react";
import { Apple, Smartphone, Monitor } from "lucide-react";

const TABS = [
    { id: "ios", label: "iOS", icon: Apple },
    { id: "android", label: "Android", icon: Smartphone },
    { id: "desktop", label: "Masaüstü", icon: Monitor },
];

export const Tabs = ({ active, onChange }) => {
    return (
        <nav
            data-testid="tabs-nav"
            className="border-b border-white/10"
        >
            <div className="max-w-5xl mx-auto px-6">
                <ul className="flex items-center justify-center gap-2 sm:gap-12 md:gap-24">
                    {TABS.map((tab) => {
                        const Icon = tab.icon;
                        const isActive = active === tab.id;
                        return (
                            <li key={tab.id}>
                                <button
                                    type="button"
                                    onClick={() => onChange(tab.id)}
                                    data-testid={`tab-${tab.id}`}
                                    className={`tab-underline relative inline-flex items-center gap-2 py-5 px-3 sm:px-4 text-sm sm:text-base font-medium transition-colors ${
                                        isActive
                                            ? "text-[#D4AF37] active"
                                            : "text-white/70 hover:text-white"
                                    }`}
                                >
                                    <Icon className="w-4 h-4 sm:w-5 sm:h-5" />
                                    {tab.label}
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </nav>
    );
};
